import { Controller } from "@hotwired/stimulus";

// Keeps a colour swatch in sync with its text input, and lets clicking the swatch
// open the native colour picker. The picker writes a hex into the text field, but
// the text field stays the source of truth — so rgba()/named/var() values typed by
// hand are preserved (the picker just assists).
export default class extends Controller {
  static targets = ["dot", "input", "picker"];

  connect() {
    this.update();
  }

  update() {
    if (!this.hasDotTarget || !this.hasInputTarget) return;
    const value = this.inputTarget.value.trim();
    this.dotTarget.style.background = value || "transparent";
    if (this.hasPickerTarget && /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(value)) {
      this.pickerTarget.value =
        value.length === 4 ? "#" + value.slice(1).replace(/./g, "$&$&") : value;
    }
  }

  pick() {
    if (!this.hasPickerTarget || !this.hasInputTarget) return;
    this.inputTarget.value = this.pickerTarget.value;
    this.update();
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }));
  }
}
